import PropTypes from "prop-types";
import React from "react";

import { Drawer, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { NextDayIndicator } from "../NextDayIndicator";
import { OvernightIndicator } from "../OvernightIndicator";
import styles from "./IndicatorTooltip.module.scss";

/**
 * IndicatorTooltip displays either the Next Day or Overnight indicator
 * with additional explanatory text in a drawer popup.
 */

export const IndicatorTooltip = (props) => {
  const { className, indicatorType = "NEXTDAY" } = props;

  return <Drawer {...getDrawerProps()} />;

  function getDrawerProps() {
    return {
      alignedRight: false,
      allowEventsOnClickOff: true,
      captionProps: {
        width: "small",
      },
      children: getDrawerChildren(),
      className,
      closeOnClickOff: true,
      showPointer: true,
      styleType: "no-style",
      triggerComponent: "link",
      triggerContent: getTriggerContent(),
    };
  }

  function getDrawerChildren() {
    return indicatorType === "OVERNIGHT"
      ? renderOvernightAdjoinContent()
      : renderNextDayAdjoinContent();
  }

  function getTriggerContent() {
    return indicatorType === "OVERNIGHT" ? <OvernightIndicator /> : <NextDayIndicator />;
  }

  function renderNextDayAdjoinContent() {
    return (
      <div className={styles.indicatorCaptionContent}>
        <Text>{i18n("IndicatorTooltip__NEXT_DAY_CAPTION")}</Text>
      </div>
    );
  }

  function renderOvernightAdjoinContent() {
    return (
      <div className={styles.indicatorCaptionContent}>
        <Text>{i18n("IndicatorTooltip__OVERNIGHT_PARAGRAPH_ONE")}</Text>
        <Text>{i18n("IndicatorTooltip__OVERNIGHT_PARAGRAPH_TWO")}</Text>
      </div>
    );
  }
};

IndicatorTooltip.propTypes = {
  /** Additional class for positioning the component. */
  className: PropTypes.string,

  /** The type of indicator to display. */
  indicatorType: PropTypes.oneOf(["NEXTDAY", "OVERNIGHT"]),
};
